module.exports = __webpack_public_path__ + "static/img/rect-tips-mid.7427364b.png";